module.exports = __webpack_public_path__ + "img/home-ipad-fg_en.ca1221c.jpg";